import { render, staticRenderFns } from "./UpdateHandler.vue?vue&type=template&id=a8fe3b16&scoped=true&"
import script from "./UpdateHandler.vue?vue&type=script&lang=js&"
export * from "./UpdateHandler.vue?vue&type=script&lang=js&"
import style0 from "./UpdateHandler.vue?vue&type=style&index=0&id=a8fe3b16&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fe3b16",
  null
  
)

export default component.exports